/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes').directive('accAddNewFolder', [
    '$document',
    '$routeParams',
    'operationComplete',
    function ($document, $routeParams, operationComplete) {
        return {
            scope: {
                model: '=',
                leftCellOffset: '@',
                rightCellOffset: '@',
                hasSelectedNodes: '<'
            },
            replace: true,
            template:
                '<tr id="add-new-folder-row" ng-hide="shouldHide">\
                    <td class="synced text-center" colspan="{{leftCellOffset}}"></td>\
                    <td class="type text-center">\
                        <acc-resource-type-icon node="{is_directory: true}"></acc-resource-type-icon>\
                    </td>\
                    <td class="name">\
                        <form\
                            id="add-new-folder-form"\
                            name="addNewFolder"\
                            class="form-inline"\
                        >\
                            <input\
                                id="new_node"\
                                class="input-xlarge"\
                                ng-model="newNode.name"\
                                size="30"\
                                type="text"\
                                required\
                            >\
                            <button\
                                id="new-folder-save"\
                                class="btn btn-primary"\
                                ng-click="save()"\
                                ng-disabled="addNewFolder.$invalid || saving"\
                            >\
                                {{ \'Save\' | translate}}\
                            </button>\
                            <button\
                                id="new-folder-cancel"\
                                class="btn"\
                                ng-click="cancel()"\
                            >\
                                {{ \'Cancel\' | translate }}\
                            </button>\
                        </form>\
                    </td>\
                    <td colspan="{{rightCellOffset}}"></td>\
                </tr>',
            link: function ($scope, $element) {
                var model = $scope.model;

                $scope.newNode = new model();
                $scope.newNode.parent_uuid = ($routeParams.uuid || 0).toString();

                _hideForm();
                $document.on('click', '#new-folder-action', function () {
                    _showForm();
                    $scope.$apply();
                    _focusInput();
                });

                $scope.$watch('hasSelectedNodes', function () {
                    _hideForm();
                });

                $scope.save = function () {
                    if ($scope.addNewFolder.$valid) {
                        $scope.saving = true;
                        model.save(
                            $scope.newNode,
                            function () {
                                operationComplete('Folder added.');
                                _hideForm();
                                $scope.$emit('reload.dataTable');
                                $scope.$emit('reload.contentStats');
                                $scope.saving = false;
                            },
                            function () {
                                $scope.saving = false;
                            }
                        );
                    }
                };

                $scope.cancel = function () {
                    _hideForm();
                };

                function _focusInput() {
                    $element.find('form input').focus();
                }

                function _showForm() {
                    $scope.shouldHide = false;
                }

                function _hideForm() {
                    $scope.newNode.name = '';
                    $scope.shouldHide = true;
                }
            }
        };
    }
]);
